import React, { useEffect, useRef, useState } from "react";
import "./review.css";

const reviews = [
  {
    text: "Love the fit and feel. Perfect tee for pub outings.",
    name: "Rachel",
    rating: 5,
  },
  {
    text: "Unique design and super comfy. Feels quality.",
    name: "Ben",
    rating: 5,
  },
  {
    text: "Fast shipping and quality clothes. Definitely buying again.",
    name: "Charlie",
    rating: 5,
  },
];

const StarRating = ({ rating }) => (
  <span className="review-stars" aria-label={`${rating} out of 5 stars`}>
    <span aria-hidden="true">
      {"★".repeat(rating)}
      {"☆".repeat(5 - rating)}
    </span>
  </span>
);

const Review = () => {
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;

    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 8000);

    return () => clearTimeout(timeoutRef.current);
  }, [current, isMobile]);

  return (
    <section className="review-section">
      <div className="content-padding">
        <div className="review-inner">
          <div className="review-header">
            <p className="review-eyebrow">Customer Love</p>
            <h2>Reviews from the pub garden</h2>
            <p>Real words from people wearing Solo Pints out and about.</p>
          </div>

          {isMobile ? (
            <>
              <div className="review-slider">
                <div className="review-card" key={current}>
                  <p className="review-text">“{reviews[current].text}”</p>

                  <div className="review-footer">
                    <span className="review-name">{reviews[current].name}</span>
                    <StarRating rating={reviews[current].rating} />
                  </div>
                </div>
              </div>

              <div className="review-dots">
                {reviews.map((_, idx) => (
                  <button
                    key={idx}
                    type="button"
                    className={`review-dot ${idx === current ? "active" : ""}`}
                    onClick={() => setCurrent(idx)}
                    aria-label={`Show review ${idx + 1}`}
                    aria-current={idx === current ? "true" : "false"}
                  />
                ))}
              </div>
            </>
          ) : (
            <div className="review-row">
              {reviews.map((review, idx) => (
                <div className="review-card" key={idx}>
                  <p className="review-text">“{review.text}”</p>

                  <div className="review-footer">
                    <span className="review-name">{review.name}</span>
                    <StarRating rating={review.rating} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Review;
